import { ComponentType } from 'react';
import { CollectionImportSummaryDTO } from '@/api/trafikportalen';
import {
  IconCheck,
  IconEdit,
  IconExclamationTriangle,
  IconRefresh,
  IconTrash,
  IconSkip,
} from '@/icons';
import { StudentType } from '@/types/students';
import {
  getChildAndYouthFieldMappings,
  getStudentTravelFieldMappings,
} from '@/components/Import/fieldsLegendData';

export type ImportSummaryState = keyof CollectionImportSummaryDTO;

export type ImportState = ImportSummaryState | 'updatedManuallyModified';

interface IconProps {
  className?: string;
}

export const getImportStateMeta = (
  state: ImportState,
): { icon: ComponentType<IconProps>; textColor: string } => {
  switch (state) {
    case 'added':
      return {
        icon: IconCheck,
        textColor: 'text-green-500',
      };
    case 'updated':
      return {
        icon: IconEdit,
        textColor: 'text-yellow-500',
      };
    case 'updatedManuallyModified':
      return {
        icon: IconEdit,
        textColor: 'text-orange-500',
      };
    case 'restored':
      return {
        icon: IconRefresh,
        textColor: 'text-blue-500',
      };
    case 'removed':
      return {
        icon: IconTrash,
        textColor: 'text-yellow-500',
      };
    case 'skipped':
      return {
        icon: IconSkip,
        textColor: 'text-text-800',
      };
    case 'failed':
      return {
        icon: IconExclamationTriangle,
        textColor: 'text-red-500',
      };
    case 'confirmed':
      return {
        icon: IconCheck,
        textColor: 'text-green-500',
      };
  }
};

export const getComparisonFields = (
  type: StudentType,
  disableHalfProduct = false,
): string[] => {
  switch (type) {
    case 'travels':
    case 'transportation':
      return getStudentTravelFieldMappings(disableHalfProduct).map(
        (f) => f.apiField,
      );
    case 'child-and-youth':
      return getChildAndYouthFieldMappings(disableHalfProduct).map(
        (f) => f.apiField,
      );
  }
};
